(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[724],{

/***/ 2372:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expo/halls/[hall-ID]/booths/[id]",
      function () {
        return __webpack_require__(9620);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const Floor = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(20), __webpack_require__.e(440), __webpack_require__.e(903), __webpack_require__.e(905)]).then(__webpack_require__.bind(__webpack_require__, 5905)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5905)
            ]
    }
});
const FloorMemo = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Floor, {});
};
const FloorWrapper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(FloorMemo);
/* harmony default export */ __webpack_exports__["Z"] = (FloorWrapper);


/***/ }),

/***/ 9620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_fiber_components_FloorWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1188);
/* harmony import */ var _store_useRouterStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _configs_HALLS_CONFIG__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8767);
/* harmony import */ var _animations_animateBlackBanner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1948);







const Booth = ()=>{
    const { setBoothID , setHallID , hallID  } = (0,_store_useRouterStore__WEBPACK_IMPORTED_MODULE_2__/* .useRouterStore */ .U)();
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!query.id && !query["hall-ID"]) return;
        setBoothID(query.id);
        if (hallID !== query[_configs_HALLS_CONFIG__WEBPACK_IMPORTED_MODULE_5__/* .HALL_ID */ .P8]) {
            (0,_animations_animateBlackBanner__WEBPACK_IMPORTED_MODULE_6__/* .animateShowBlackBanner */ .q)(()=>setHallID(query["hall-ID"]));
            return;
        }
        setHallID(query["hall-ID"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        hallID
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
Booth.r3f = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fiber_components_FloorWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
};
Booth.title = "Exhibition Booths | Building Center";
/* harmony default export */ __webpack_exports__["default"] = (Booth);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2372); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);